// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__g8gKq","title":"AfterBackImages_title__1gwEc","images":"AfterBackImages_images__2hpAg"};